import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { Router } from '@angular/router';
/**
 * Menu Item object
 */
export class MenuItem {
	/** Menu Name */
	menuName: string;
	/** Router link */
	routerLink: string;
}
/**
 * Responsive menu Component
 */
@Component({
	selector: 'app-responsive-menu',
	templateUrl: './responsive-menu.component.html',
	styleUrls: ['./responsive-menu.component.scss'],
})
export class ResponsiveMenuComponent implements OnInit, OnChanges {
	/** Array of menu Items */
	@Input() menuItems: Array<MenuItem> = [];
	/** Currently Selected Menu item's Index */
	@Input() currentIndex: number;
	/** Selected Menu item's Index event emitter */
	@Output() selectedIndex: EventEmitter<number>;
	/** UI position configuration */
	@Input() top = 109;
	/** denote wether the menu is sticky or not */
	sticky = false;
	/** */
	menuPosition = 0;
	/**
	 * Responsive menu constructor
	 * @param router - Angular Router
	 */
	constructor(private router: Router) {
		this.selectedIndex = new EventEmitter<number>();
	}

	ngOnInit() {
		this.selectedIndex.emit(this.currentIndex);
	}
	/**
	 * Host listener for scrolling
	 * @param event - scroll event
	 */
	@HostListener('window:scroll', ['$event']) onScroll(event) {
		const windowScroll = window.pageYOffset;
		if (windowScroll > this.menuPosition) {
			this.sticky = true;
		} else {
			this.sticky = false;
		}
	}

	/**
	 * updating current index whenever there is a change
	 * @param changes - Simple changes object
	 */
	ngOnChanges(changes: SimpleChanges) {
		if (changes.currentIndex !== null && changes.currentIndex !== undefined) {
			this.currentIndex = changes.currentIndex.currentValue;
		}
	}

	/**
	 * On Tab Change, changing route and emitting selected Index event
	 * @param event
	 */
	tabChange(event) {
		this.selectedIndex.emit(event.index);
		this.router.navigate([this.menuItems[event.index].routerLink]);
	}
}
